import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getTotalRevenueShipped = {
  name: "getTotalRevenueShipped" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
